export const SET_ORGANIZATION_LIST = 'SET_ORGANIZATION_LIST'



// WEBPACK FOOTER //
// ./src/types/organization.js